import React from 'react';
import ArticleCardBase from '../../Base';
import CardMedia from '../../../../CardMedia';

import './styles.scss';

const SquareQuote1 = ({ data, endCard }) => {
  const {
    backgroundColor,
    articleAsset,
    paragraphC22,
    dashColor,
    personName,
    articleAsset2,
    imageFit
  } = data;

  return (
    <ArticleCardBase variation="square" accentColor1={backgroundColor} endCard={endCard}>
      <section className="card-container square-quote-1">
        <img
          alt="Quote"
          src={articleAsset[0].url}
          className={`square-quote-1__quote-sign square-quote-1__quote-sign--${imageFit}`}
        />
        <div className="square-quote-1__quote-wrapper">
          <div
            className="square-quote-1__quote-text"
            dangerouslySetInnerHTML={{ __html: paragraphC22 }}
          />
          <div
            className="square-quote-1__person-name"
            dangerouslySetInnerHTML={{
              __html: `<span class="square-quote-1__person-name__dash" style="color: ${dashColor}"></span> ${personName}`
            }}
          />
          {articleAsset.length ? (
            <div className="square-quote-1__headshot-wrapper">
              <CardMedia
                url={articleAsset2[0].url}
                title={articleAsset2[0].title}
                mimeType={articleAsset2[0].mimeType}
                mediaContainerClasses="square-quote-1__headshot"
                imageFit={imageFit}
                cardImageSizes={[
                  { actual: 131, intrinsic: 250 },
                  { actual: 228, intrinsic: 450 }
                ]}
              />
            </div>
          ) : null}
        </div>
      </section>
    </ArticleCardBase>
  );
};

export default SquareQuote1;
